export const officeBlokDict = {
  sendEnquiry: {
    en: 'Send enquiry',
    de: 'Anfrage absenden',
    ru: 'Отправить запрос',
    tr: 'Sorgu gönder',
    es: 'Enviar consulta',
  },
  businessHours: {
    en: 'Business hours',
    de: 'Öffnungszeiten',
    ru: 'График работы',
    tr: 'Çalışma saatleri',
    es: 'Horario de atención',
  },
  scheduleMeeting: {
    en: 'Schedule a meeting',
    de: 'Termin vereinbaren',
    ru: 'Запланировать встречу',
    tr: 'Toplantı planla',
    es: 'Programar una reunión',
  },
};
